import React from "react";
import _ from "lodash";
import { useTheme } from "@mui/styles";
import { useNavigate, useOutletContext } from "react-router";
import { Button, SIZE, COLOR } from "@metacrm/metacrm-material-ui/dist/Button";
import { parseCustomDomainUrl } from "features/helpers/utils";
import { StyledContainer } from "./Issue.styles";
import { useIntl } from "react-intl";

function IssueIntegrationView({
  canEdit,
  title,
  message,
  img = require("assets/img/not-integrated.svg").default,
}) {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const theme = useTheme();
  const [entityName, isCustomDomain] = useOutletContext();

  return (
    <StyledContainer style={{ background: "#FAFAFD" }}>
      <div
        className="modalHeader startRow"
        style={{ padding: "30px 18px 0px" }}>
        {"Issue History"}
      </div>
      <div
        style={{
          display: "flex",
          height: "100%",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}>
        <img src={img} alt="" />
        <div
          style={{
            color: theme.customColors.grey[700],
            fontWeight: theme.fontWeight.BOLD,
            fontSize: 14,
            paddingTop: 13,
          }}>
          {title}
        </div>
        <div
          style={{
            color: theme.customColors.grey[600],
            fontSize: 14,
            padding: "8px 0px 15px",
            maxWidth: 302,
          }}>
          {message}
        </div>
        {canEdit && (
          <Button
            color={COLOR.SECONDARY}
            size={SIZE.SMALL}
            onClick={() => {
              navigate(
                parseCustomDomainUrl(
                  isCustomDomain,
                  entityName,
                  "/settings/general/integration/add"
                )
              );
            }}>
            {formatMessage({ id: "global.btn.integrate" })}
          </Button>
        )}
      </div>
    </StyledContainer>
  );
}

export default IssueIntegrationView;
